"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isJWT = void 0;
/**
 * This will evaluate a string and determine whether it could be a JWT. We make
 * three assertions to test this:
 *   - The token could start with bearer
 *   - The token could have the three JWT fragments '<chars>.<chars>.<chars>'
 *   - OR the token could be the legacy format, as in it contains the 'r:' prefix, followed
 *     by a combination of alphanumeric chars of any case.
 * @param token String
 */
const isJWT = (token) => (/^Bearer .*/.test(token) || /.*\..*\..*/.test(token)) && !/[token]? ?r:[A-z0-9]*/.test(token);
exports.isJWT = isJWT;
//# sourceMappingURL=jwt.js.map